import React, { Component } from "react";

class ToolsProgressBadge extends Component {
	render() {
		const { remainingCount, totalCount, doneWord, todoWord } = this.props;

		const isAllDone = remainingCount === 0;
		if (isAllDone) {
			return (
				<span className="tk-badge tk-badge--success">
					All {totalCount} {doneWord}
				</span>
			);
		}

		return (
			<span className="tk-badge tk-badge--warning">
				{remainingCount} of {totalCount} still to {todoWord}
			</span>
		);
	}
}

export default ToolsProgressBadge;
